import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import * as paths from 'Paths';


const UsersRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/users/users" */
    'routes/Users/UsersRoute'
  )
));

const AddUserRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/users/add-user" */
    'routes/Users/AddUserRoute'
  )
));

const EditUserRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/users/edit-user" */
    'routes/Users/EditUserRoute'
  )
));

const MembershipsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/users/memberships" */
    'routes/Users/MembershipsRoute'
  )
));

const UserDetailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/users/user-details" */
    'routes/Users/UserDetailsRoute'
  )
));

const EditUserDetailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/users/edit-user-details" */
    'routes/Users/EditUserDetailsRoute'
  )
));

const ChangeEmailRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/users/change-email" */
    'routes/Users/ChangeEmailRoute'
  )
));

const ChangePasswordRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/users/change-password" */
    'routes/Users/ChangePasswordRoute'
  )
));

const SetupUserRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/users/setup-user" */
    'routes/Users/SetupUserRoute'
  )
));


const getUsersRoutes = () => {
  return [
    {path: paths.getPathUsers(), component: UsersRoute},
    {path: paths.getPathAddUser(), component: AddUserRoute},
    {path: paths.getPathEditUser(":userId"), component: EditUserRoute},
    {path: paths.getPathUserMemberships(":userId"), component: MembershipsRoute},

    {path: paths.getPathUserDetails(), component: UserDetailsRoute},
    {path: paths.getPathEditUserDetails(), component: EditUserDetailsRoute},

    {path: paths.getPathChangeEmail(), component: ChangeEmailRoute},
    {path: paths.getPathChangePassword(), component: ChangePasswordRoute},
    {path: paths.getPathSetupUser(), component: SetupUserRoute},
  ]
}



export { getUsersRoutes };
